import { Box } from '@chakra-ui/react'

/** Initial-avatar from team name: first letter of each word, max 2 chars. */
export const teamInitials = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(w => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase()

interface Props {
  name: string
  logoUrl?: string
  accent: string
  size?: number
}

/** Circular team avatar — logo image when present, else accent-filled initials. */
const TeamCardAvatar = ({ name, logoUrl, accent, size = 40 }: Props) => {
  const dimension = `${size}px`
  if (logoUrl) {
    return (
      <Box
        width={dimension}
        height={dimension}
        borderRadius="full"
        overflow="hidden"
        flexShrink={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg={`${accent}22`}
      >
        <Box as="img" src={logoUrl} alt={name} width="100%" height="100%" objectFit="cover" />
      </Box>
    )
  }
  return (
    <Box
      width={dimension}
      height={dimension}
      borderRadius="full"
      bg={accent}
      flexShrink={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="white"
      fontSize="14px"
      fontWeight={600}
    >
      {teamInitials(name)}
    </Box>
  )
}

export default TeamCardAvatar
